import * as CustomerActions from './customer.actions';
import * as PolicyActions from './policy.actions';
import * as QueryActions from './query.actions';
import * as CertificateActions from './certificate.actions';
import * as CertificateHistoricalActions from './certificate-historical.actions';
import * as CertificateTypeActions from './certificate-type.actions';
import * as RoleActions from './role.actions';
import * as AreaActions from './area.actions';
import * as GeneralConfigActions from './general-config.actions';

export {
    CustomerActions,
    PolicyActions,
    CertificateActions,
    CertificateHistoricalActions,
    QueryActions,
    CertificateTypeActions,
    RoleActions,
    AreaActions,
    GeneralConfigActions,
};
